module.exports = __webpack_public_path__ + "img/sable-gray.85b0f42a.svg";